import { render } from "./index.vue?vue&type=template&id=6b8ad1f8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__